import { toLocaleString4 } from '../strings'

export const overviewStockParser = (data: any[]): any[] => {
  const rows: any[] = []

  for (const entity of data) {
    rows.push({
      posicao: entity.posicao,
      codigo: entity.codigo,
      nome: entity.descricao,
      valor: toLocaleString4(entity.valor)
    })
  }

  return rows
}
